export enum UpdateCardRadioValues {
  UPDATE_CARD = 'update-card',
  DONT_UPDATE_CARD = 'dont-update-card'
}

export const FORMATTED_UPDATE_CARD_RADIO_VALUES = {
  [UpdateCardRadioValues.UPDATE_CARD]: 'Save as new card for recurring charge',
  [UpdateCardRadioValues.DONT_UPDATE_CARD]: 'Use only for this occurrence'
}
